import { Reducer } from 'redux';
import ActionTypes, { TInteractiveState, TVoteEnd } from './types';

export const initialState: TInteractiveState = {
  test: null,
  vote: null,
  voteRating: null,
  link: null,
  testResult: null,
  voteResult: null,
  voteRatingResult: null,
  votesGroup: null,
  votesRatingGroup: null,
  rating: null,
  interactive: null,
  doneTest: null,
  doneVote: null,
  doneVoteRating: null,
  doneVoteGroup: null,
  doneVoteRatingGroup: null,
  loading: false,
  error: null,
  redirect: null,
};

const reducer: Reducer<TInteractiveState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CHECK_DONE_VOTE_GROUP_R:
    case ActionTypes.CHECK_DONE_VOTE_RATING_GROUP_R:
    case ActionTypes.GET_DEFAULT_LINK_R:
    case ActionTypes.CHECK_DONE_VOTE_R:
    case ActionTypes.CHECK_DONE_TEST_R:
    case ActionTypes.SEND_VOTE_GROUP_R:
    case ActionTypes.SEND_VOTE_R:
    case ActionTypes.SEND_VOTE_RATING_R:
    case ActionTypes.SEND_TEST_R:
      return { ...state, doneTest: null, doneVote: null, doneVoteRating: null, error: '', loading: true };

    case ActionTypes.SHOW_INTERACTIVE_R:
      return { ...state, interactive: null, error: '', loading: true };

    case ActionTypes.SEND_VOTE_GROUP_S:
    case ActionTypes.SHOW_INTERACTIVE_S:
      return { ...state, loading: false };
    case ActionTypes.CHECK_DONE_TEST_S:
      return { ...state, doneTest: action.payload, loading: false };
    case ActionTypes.CHECK_DONE_VOTE_S:
      return { ...state, doneVote: action.payload, loading: false };
    case ActionTypes.CHECK_DONE_VOTE_RATING_S:
      return { ...state, doneVoteRating: action.payload, loading: false };
    case ActionTypes.GET_DEFAULT_LINK_S:
      return { ...state, link: action.payload, loading: false };
    case ActionTypes.SEND_TEST_S:
      return { ...state, doneTest: action.payload, loading: false };
    case ActionTypes.SEND_VOTE_S:
      return { ...state, doneVote: action.payload, loading: false };
    case ActionTypes.SEND_VOTE_RATING_S:
      return { ...state, doneVoteRating: action.payload, loading: false };
    case ActionTypes.CHECK_DONE_VOTE_GROUP_S:
      return { ...state, doneVoteGroup: action.payload, loading: false };
    case ActionTypes.CHECK_DONE_VOTE_RATING_GROUP_S:
      return { ...state, doneVoteRatingGroup: action.payload, loading: false };

    case ActionTypes.SET_TEST:
      return { ...state, test: action.payload };
    case ActionTypes.SET_VOTE:
      return { ...state, vote: action.payload };
    case ActionTypes.SET_VOTE_RATING:
      return { ...state, voteRating: action.payload };
    case ActionTypes.SET_LINK:
      return { ...state, link: action.payload };
    case ActionTypes.SET_RESULT_TEST:
      return { ...state, testResult: action.payload };
    case ActionTypes.SET_RESULT_VOTE:
      return { ...state, voteResult: action.payload };
    case ActionTypes.SET_RESULT_VOTE_RATING:
      return { ...state, voteRatingResult: action.payload };
    case ActionTypes.SET_RATING:
      return { ...state, rating: action.payload };
    case ActionTypes.SET_VOTES_GROUP:
      return { ...state, votesGroup: action.payload };
    case ActionTypes.SET_VOTES_RATING_GROUP:
      return { ...state, votesRatingGroup: action.payload };

    case ActionTypes.SET_END_VOTE: {
      const vote = action.payload as TVoteEnd;
      return {
        ...state,
        votesGroup: state.votesGroup
          ? {
              ...state.votesGroup,
              votes: state.votesGroup.votes.map((item) => {
                if (item.id === vote.id) {
                  return { ...item, isFinish: vote.status };
                }
                return item;
              }),
            }
          : null,
      };
    }
    case ActionTypes.SET_END_VOTE_RATING: {
      const vote = action.payload as TVoteEnd;
      return {
        ...state,
        votesRatingGroup: state.votesRatingGroup
          ? {
              ...state.votesRatingGroup,
              votes: state.votesRatingGroup.votes.map((item) => {
                if (item.id === vote.id) {
                  return { ...item, isFinish: vote.status };
                }
                return item;
              }),
            }
          : null,
      };
    }
    case ActionTypes.SET_INTERACTIVE:
      return { ...state, interactive: action.payload };
    case ActionTypes.SET_REDIRECT:
      return { ...state, redirect: action.payload };

    case ActionTypes.CHECK_DONE_VOTE_GROUP_E:
    case ActionTypes.CHECK_DONE_VOTE_RATING_GROUP_E:
    case ActionTypes.GET_DEFAULT_LINK_E:
    case ActionTypes.CHECK_DONE_VOTE_E:
    case ActionTypes.CHECK_DONE_TEST_E:
    case ActionTypes.SEND_VOTE_GROUP_E:
    case ActionTypes.SEND_VOTE_E:
    case ActionTypes.SEND_VOTE_RATING_E:
    case ActionTypes.SEND_TEST_E:
    case ActionTypes.SHOW_INTERACTIVE_E:
      return { ...state, error: action.payload, loading: false };

    case ActionTypes.CLEAR_INTERACTIVE:
      return {
        ...state,
        test: null,
        testResult: null,
        vote: null,
        voteResult: null,
        voteRating: null,
        voteRatingResult: null,
        rating: null,
        link: null,
        votesGroup: null,
        votesRatingGroup: null,
      };

    default:
      return state;
  }
};

export { reducer as InteractiveReducer };
